import { clearDisable } from '../../plugins/clickThrottling';
import { Toast } from 'vant';

export const SHOW_DIALOG = 'showDialog';
export const SHOW_TIPS_MSG = 'showTIpsMessage';
export const BINDING_DIALOG = 'bindingDialog';
export const DE_BIND_DIALOG = 'debindDialog';
export const SWICH_ACCOUNT_DIALOG = 'switchAccountDialog';
export const SWICH_TIPS_DIALOG = 'switchAccountTipsDialog';
export const HIDE_DIALOG = 'hideDialog';
export const SHOW_TOST = true;
export const HIDE_TOST = false;
export const TOST = 'tost';
export default {
  state: {
    showTost: false,
    tipContent: '',
    showDialog: false,
    showingDialogType: '',
    BINDING_DIALOG,
    SHOW_TIPS_MSG,
    DE_BIND_DIALOG,
    SWICH_ACCOUNT_DIALOG,
    SWICH_TIPS_DIALOG,
    tipsConfirmCallbackType: '',
    tipsCancelCallback: '',
    tipsCloseCallBack: ''
  },
  mutations: {
    [SHOW_DIALOG](state, TYPE) {
      state.showDialog = true;
      state.showingDialogType = TYPE;
    },
    [SHOW_TIPS_MSG](
      state,
      { message, tipsConfirmCallback, tipsCancelCallback, tipsCloseCallBack }
    ) {
      state.tipContent = message;
      state.tipsConfirmCallbackType = tipsConfirmCallback || '';
      state.tipsCancelCallback = tipsCancelCallback || '';
      state.tipsCloseCallBack = tipsCloseCallBack || '';
      clearDisable();
    },
    [HIDE_DIALOG](state) {
      state.showDialog = false;
      state.showingDialogType = '';
    }
  },
  actions: {
    [SHOW_TIPS_MSG]({ commit, dispatch }, options) {
      dispatch(SHOW_DIALOG, SWICH_TIPS_DIALOG);
      commit(SHOW_TIPS_MSG, options);
    },
    [SHOW_DIALOG]({ commit }, TYPE) {
      commit(SHOW_DIALOG, TYPE);
    },
    [HIDE_DIALOG]({ commit }) {
      commit(HIDE_DIALOG);
    },
    [TOST]({ commit }, message) {
      Toast({
        message,
        duration: 3000
      });
    }
  }
};
